import React, { useState, useEffect } from 'react'
import classNames from 'classnames'

export const Switch = ({
  label = '',
  checked = false,
  onChange = (val) => null,
  isDisabled = false
}) => {

  const [isChecked, setIsChecked] = useState(checked)

  useEffect(() => {
    if (checked !== isChecked) {
      setIsChecked(checked)
    }
  }, [checked])

  const handleToggle = () => {
    setIsChecked(prevState => {
      onChange(!prevState)
      return !prevState
    })
  }

  return (
    <div className='chart-editor-switcher'>
      {label &&
        <div className='chart-editor__label'>
          <label className="text-field__label1" htmlFor='switcher'>{label}</label>
        </div>
      }
      <label className='switch switch1'>
        <input
          type="checkbox"
          id='switcher'
          disabled={isDisabled}
          checked={isChecked}
          onChange={handleToggle}
        />
        <span
          className={classNames('slider round accent2', {
            'slider-active': isChecked,
          })}
        >
          <span className='slider-round-overlay' />
        </span>
      </label>
    </div>
  )
}